import { SET_UPLOADS, FINISH_UPLOADS } from '../constants'

const initialState = {
  uploads: [],
  progress: 100,
  inProgress: false,
  bytesTotal: 0,
  bytesUploaded: 0
}

const calcProgress = (total, uploaded) => {
  if (total === uploaded) return 100
  if (uploaded === 0) return 0
  const result = parseInt((uploaded / total) * 100)
  return result
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case FINISH_UPLOADS:
      const allDone = state.uploads.every(u => calcProgress(u.file.size, u.file.loaded) === 100)
      if (!allDone) {
        return state
      }

      console.log('Uploads finished')
      // Clear uploads
      if (window.uploads !== undefined && window.uploads !== null) {
        window.uploads.splice(0, window.uploads.length)
      }
      action.payload = []
      // Fall through to next case
    case SET_UPLOADS:
      const uploads = action.payload
      let bytesTotal = 0
      let bytesUploaded = 0
      for (let i = 0; i < uploads.length; i++) {
        bytesTotal += uploads[i].file.size
        bytesUploaded += uploads[i].file.loaded
      }
      const progress = calcProgress(bytesTotal, bytesUploaded)
      return {
        ...state,
        uploads: uploads,
        progress: progress,
        inProgress: (progress < 100),
        bytesTotal: bytesTotal,
        bytesUploaded: bytesUploaded
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/uploads.js